import {
  StringSerializer_getInstance2wffkbpdux3h9 as StringSerializer_getInstance,
  BooleanSerializer_getInstance1t8habeqgiyq1 as BooleanSerializer_getInstance,
  IntSerializer_getInstance2q7s8kvk1il5u as IntSerializer_getInstance,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import { LinkedHashSetSerializer3ncla559t2lx7 as LinkedHashSetSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/CollectionSerializers.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance3hlj875zwihx0 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import {
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  toString1pkumu07cwy4m as toString,
  createThis2j2avj17cvnv2 as createThis,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
  SerializerFactory1qv9hivitncuv as SerializerFactory,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { ConditionSerializer21tf3x2n3amih as ConditionSerializer } from '../../../../lightning-server-shared/com/lightningkite/lightningdb/ConditionSerialization.mjs';
import { Always_getInstancecs10mhg5aot2 as Always_getInstance } from '../../../../lightning-server-shared/com/lightningkite/lightningdb/Condition.mjs';
import { Index19x9ylte4qic1 as Index } from '../../../../lightning-server-shared/com/lightningkite/lightningdb/Annotations.mjs';
import { HasId2loj0ucxxxo6d as HasId } from '../../../../lightning-server-shared/com/lightningkite/lightningdb/HasId.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { Comparable198qfk8pnblz0 as Comparable } from '../../../../kotlin-kotlin-stdlib/kotlin/Comparable.mjs';
import { DeferToContextualUuidSerializer_getInstance3t53sgmdyoff4 as DeferToContextualUuidSerializer_getInstance } from '../../../../lightning-server-shared/com/lightningkite/UUID.mjs';
import { Companion_getInstance3n9as6ds1py67 as Companion_getInstance } from '../../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import { InstantIso8601Serializer_getInstance2sfqqbic5n1oz as InstantIso8601Serializer_getInstance } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/serializers/InstantSerializers.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { values3tr2ffumvy98e as values } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/DayOfWeek.mjs';
import { createSimpleEnumSerializer2guioz11kk1m0 as createSimpleEnumSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Enums.mjs';
import { LocalTimeIso8601Serializer_getInstance1gy7xllc2odvq as LocalTimeIso8601Serializer_getInstance } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/serializers/LocalTimeSerializers.mjs';
import { TimeZoneSerializer_getInstanceqa9aveo7y5x8 as TimeZoneSerializer_getInstance } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/serializers/TimeZoneSerializers.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function EventType$Companion$$childSerializers$_anonymous__melmyy() {
  return new (LinkedHashSetSerializer())(StringSerializer_getInstance());
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.q8l_1 = [null, lazy(tmp_0, EventType$Companion$$childSerializers$_anonymous__melmyy)];
      }
      k2a() {
        return $serializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.notifications.EventType', this, 2);
        tmp0_serialDesc.a1b('name', false);
        tmp0_serialDesc.a1b('tags', true);
        this.q9i_1 = tmp0_serialDesc;
      }
      r9i(encoder, value) {
        var tmp0_desc = this.q9i_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_0().q8l_1;
        tmp1_output.a15(tmp0_desc, 0, value.v8l_1);
        if (tmp1_output.h15(tmp0_desc, 1) ? true : !equals(value.w8l_1, emptySet())) {
          tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.w8l_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.r9i(encoder, value instanceof EventType() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.q9i_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.l13(tmp0_desc);
        var tmp7_cached = Companion_getInstance_0().q8l_1;
        if (tmp6_input.a14()) {
          tmp4_local0 = tmp6_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.x13(tmp0_desc, 1, tmp7_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.x13(tmp0_desc, 1, tmp7_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return EventType().s9i(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.q9i_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance_0().q8l_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), tmp0_cached[1].f2()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
var EventTypeClass;
function EventType() {
  if (EventTypeClass === VOID) {
    class $ {
      constructor(name, tags) {
        Companion_getInstance_0();
        tags = tags === VOID ? emptySet() : tags;
        this.v8l_1 = name;
        this.w8l_1 = tags;
      }
      equals(other) {
        var tmp;
        if (other instanceof EventType()) {
          tmp = this.v8l_1 === other.v8l_1;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return getStringHashCode(this.v8l_1);
      }
      t9i(name, tags) {
        return new (EventType())(name, tags);
      }
      y8l(name, tags, $super) {
        name = name === VOID ? this.v8l_1 : name;
        tags = tags === VOID ? this.w8l_1 : tags;
        return $super === VOID ? this.t9i(name, tags) : $super.t9i.call(this, name, tags);
      }
      toString() {
        return 'EventType(name=' + this.v8l_1 + ', tags=' + toString(this.w8l_1) + ')';
      }
      static s9i(seen0, name, tags, serializationConstructorMarker) {
        Companion_getInstance_0();
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance().q9i_1);
        }
        var $this = createThis(this);
        $this.v8l_1 = name;
        if (0 === (seen0 & 2))
          $this.w8l_1 = emptySet();
        else
          $this.w8l_1 = tags;
        return $this;
      }
    }
    initMetadataForClass($, 'EventType', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
    EventTypeClass = $;
  }
  return EventTypeClass;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.notifications.EventSubscription.Info', null, 5);
        tmp0_serialDesc.a1b('filter', true);
        tmp0_serialDesc.a1b('frequency', true);
        tmp0_serialDesc.a1b('email', true);
        tmp0_serialDesc.a1b('push', true);
        tmp0_serialDesc.a1b('sms', true);
        this.r8s_1 = tmp0_serialDesc;
      }
      b2j(typeSerial0) {
        return $serializer_0().w9i(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.b2j(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_1() {
  if (Companion_instance_0 === VOID)
    new (Companion_0())();
  return Companion_instance_0;
}
var $serializerClass_0;
function $serializer_0() {
  if ($serializerClass_0 === VOID) {
    class $ {
      static x9i() {
        var $this = createThis(this);
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.notifications.EventSubscription.Info', $this, 5);
        tmp0_serialDesc.a1b('filter', true);
        tmp0_serialDesc.a1b('frequency', true);
        tmp0_serialDesc.a1b('email', true);
        tmp0_serialDesc.a1b('push', true);
        tmp0_serialDesc.a1b('sms', true);
        $this.u9i_1 = tmp0_serialDesc;
        return $this;
      }
      y9i(encoder, value) {
        var tmp0_desc = this.u9i_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.z9i_1.equals(Always_getInstance())) {
          tmp1_output.c15(tmp0_desc, 0, new (ConditionSerializer())(this.v9i_1), value.z9i_1);
        }
        if (tmp1_output.h15(tmp0_desc, 1) ? true : !value.a9j_1.equals(Companion_getInstance_6().e9j())) {
          tmp1_output.c15(tmp0_desc, 1, $serializer_getInstance_1(), value.a9j_1);
        }
        if (tmp1_output.h15(tmp0_desc, 2) ? true : !(value.b9j_1 === true)) {
          tmp1_output.s14(tmp0_desc, 2, value.b9j_1);
        }
        if (tmp1_output.h15(tmp0_desc, 3) ? true : !(value.c9j_1 === true)) {
          tmp1_output.s14(tmp0_desc, 3, value.c9j_1);
        }
        if (tmp1_output.h15(tmp0_desc, 4) ? true : !(value.d9j_1 === false)) {
          tmp1_output.s14(tmp0_desc, 4, value.d9j_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.y9i(encoder, value instanceof Info() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.u9i_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = false;
        var tmp7_local3 = false;
        var tmp8_local4 = false;
        var tmp9_input = decoder.l13(tmp0_desc);
        if (tmp9_input.a14()) {
          tmp4_local0 = tmp9_input.x13(tmp0_desc, 0, new (ConditionSerializer())(this.v9i_1), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp9_input.x13(tmp0_desc, 1, $serializer_getInstance_1(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp9_input.n13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp9_input.n13(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp9_input.n13(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp9_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp9_input.x13(tmp0_desc, 0, new (ConditionSerializer())(this.v9i_1), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp9_input.x13(tmp0_desc, 1, $serializer_getInstance_1(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp9_input.n13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp9_input.n13(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp9_input.n13(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp9_input.m13(tmp0_desc);
        return Info().f9j(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
      }
      az() {
        return this.u9i_1;
      }
      r1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [new (ConditionSerializer())(this.v9i_1), $serializer_getInstance_1(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance()];
      }
      s1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.v9i_1];
      }
      static w9i(typeSerial0) {
        var $this = this.x9i();
        $this.v9i_1 = typeSerial0;
        return $this;
      }
    }
    initMetadataForClass($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_0 = $;
  }
  return $serializerClass_0;
}
function EventSubscription$Companion$$childSerializers$_anonymous__jduelp() {
  return new (LinkedHashSetSerializer())(IntSerializer_getInstance());
}
var InfoClass;
function Info() {
  if (InfoClass === VOID) {
    class $ {
      constructor(filter, frequency, email, push, sms) {
        Companion_getInstance_1();
        filter = filter === VOID ? Always_getInstance() : filter;
        frequency = frequency === VOID ? Companion_getInstance_6().e9j() : frequency;
        email = email === VOID ? true : email;
        push = push === VOID ? true : push;
        sms = sms === VOID ? false : sms;
        this.z9i_1 = filter;
        this.a9j_1 = frequency;
        this.b9j_1 = email;
        this.c9j_1 = push;
        this.d9j_1 = sms;
      }
      toString() {
        return 'Info(filter=' + toString(this.z9i_1) + ', frequency=' + this.a9j_1.toString() + ', email=' + this.b9j_1 + ', push=' + this.c9j_1 + ', sms=' + this.d9j_1 + ')';
      }
      hashCode() {
        var result = this.z9i_1.hashCode();
        result = imul(result, 31) + this.a9j_1.hashCode() | 0;
        result = imul(result, 31) + getBooleanHashCode(this.b9j_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.c9j_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.d9j_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Info()))
          return false;
        if (!this.z9i_1.equals(other.z9i_1))
          return false;
        if (!this.a9j_1.equals(other.a9j_1))
          return false;
        if (!(this.b9j_1 === other.b9j_1))
          return false;
        if (!(this.c9j_1 === other.c9j_1))
          return false;
        if (!(this.d9j_1 === other.d9j_1))
          return false;
        return true;
      }
      static f9j(seen0, filter, frequency, email, push, sms, serializationConstructorMarker) {
        Companion_getInstance_1();
        if (!(0 === (0 & seen0))) {
          throwMissingFieldException(seen0, 0, Companion_getInstance_1().r8s_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.z9i_1 = Always_getInstance();
        else
          $this.z9i_1 = filter;
        if (0 === (seen0 & 2))
          $this.a9j_1 = Companion_getInstance_6().e9j();
        else
          $this.a9j_1 = frequency;
        if (0 === (seen0 & 4))
          $this.b9j_1 = true;
        else
          $this.b9j_1 = email;
        if (0 === (seen0 & 8))
          $this.c9j_1 = true;
        else
          $this.c9j_1 = push;
        if (0 === (seen0 & 16))
          $this.d9j_1 = false;
        else
          $this.d9j_1 = sms;
        return $this;
      }
    }
    initMetadataForClass($, 'Info', Info, VOID, VOID, VOID, VOID, {0: Companion_getInstance_1});
    InfoClass = $;
  }
  return InfoClass;
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      constructor() {
        Companion_instance_1 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.a8k_1 = [null, null, null, lazy(tmp_0, EventSubscription$Companion$$childSerializers$_anonymous__jduelp), null, null, null, null];
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.notifications.EventSubscription', null, 8);
        tmp0_serialDesc.a1b('_id', false);
        tmp0_serialDesc.a1b('requestedFilter', false);
        tmp0_serialDesc.a1b('readPermissions', false);
        tmp0_serialDesc.a1b('filterHashes', false);
        tmp0_serialDesc.a1b('frequency', false);
        tmp0_serialDesc.a1b('email', false);
        tmp0_serialDesc.a1b('push', false);
        tmp0_serialDesc.a1b('sms', false);
        this.b8k_1 = tmp0_serialDesc;
      }
      c8k(typeSerial0) {
        return $serializer_1().i9j(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.c8k(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_1;
function Companion_getInstance_2() {
  if (Companion_instance_1 === VOID)
    new (Companion_1())();
  return Companion_instance_1;
}
var $serializerClass_1;
function $serializer_1() {
  if ($serializerClass_1 === VOID) {
    class $ {
      static j9j() {
        var $this = createThis(this);
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.notifications.EventSubscription', $this, 8);
        tmp0_serialDesc.a1b('_id', false);
        tmp0_serialDesc.a1b('requestedFilter', false);
        tmp0_serialDesc.a1b('readPermissions', false);
        tmp0_serialDesc.a1b('filterHashes', false);
        tmp0_serialDesc.b1b(new (Index())());
        tmp0_serialDesc.a1b('frequency', false);
        tmp0_serialDesc.a1b('email', false);
        tmp0_serialDesc.a1b('push', false);
        tmp0_serialDesc.a1b('sms', false);
        $this.g9j_1 = tmp0_serialDesc;
        return $this;
      }
      k9j(encoder, value) {
        var tmp0_desc = this.g9j_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_2().a8k_1;
        tmp1_output.c15(tmp0_desc, 0, $serializer_2().n9j(this.h9j_1), value.h8k_1);
        tmp1_output.a15(tmp0_desc, 1, value.i8k_1);
        tmp1_output.a15(tmp0_desc, 2, value.j8k_1);
        tmp1_output.c15(tmp0_desc, 3, tmp2_cached[3].f2(), value.k8k_1);
        tmp1_output.c15(tmp0_desc, 4, $serializer_getInstance_1(), value.l8k_1);
        tmp1_output.s14(tmp0_desc, 5, value.m8k_1);
        tmp1_output.s14(tmp0_desc, 6, value.n8k_1);
        tmp1_output.s14(tmp0_desc, 7, value.o8k_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.k9j(encoder, value instanceof EventSubscription() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.g9j_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = false;
        var tmp10_local6 = false;
        var tmp11_local7 = false;
        var tmp12_input = decoder.l13(tmp0_desc);
        var tmp13_cached = Companion_getInstance_2().a8k_1;
        if (tmp12_input.a14()) {
          tmp4_local0 = tmp12_input.x13(tmp0_desc, 0, $serializer_2().n9j(this.h9j_1), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp12_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp12_input.v13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp12_input.x13(tmp0_desc, 3, tmp13_cached[3].f2(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp12_input.x13(tmp0_desc, 4, $serializer_getInstance_1(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp12_input.n13(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp12_input.n13(tmp0_desc, 6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp12_input.n13(tmp0_desc, 7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp12_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp12_input.x13(tmp0_desc, 0, $serializer_2().n9j(this.h9j_1), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp12_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp12_input.v13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp12_input.x13(tmp0_desc, 3, tmp13_cached[3].f2(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp12_input.x13(tmp0_desc, 4, $serializer_getInstance_1(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp12_input.n13(tmp0_desc, 5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp12_input.n13(tmp0_desc, 6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp12_input.n13(tmp0_desc, 7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp12_input.m13(tmp0_desc);
        return EventSubscription().o9j(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, null);
      }
      az() {
        return this.g9j_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance_2().a8k_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_2().n9j(this.h9j_1), StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[3].f2(), $serializer_getInstance_1(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance()];
      }
      s1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.h9j_1];
      }
      static i9j(typeSerial0) {
        var $this = this.j9j();
        $this.h9j_1 = typeSerial0;
        return $this;
      }
    }
    initMetadataForClass($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_1 = $;
  }
  return $serializerClass_1;
}
var EventSubscriptionClass;
function EventSubscription() {
  if (EventSubscriptionClass === VOID) {
    class $ {
      constructor(_id, requestedFilter, readPermissions, filterHashes, frequency, email, push, sms) {
        Companion_getInstance_2();
        this.h8k_1 = _id;
        this.i8k_1 = requestedFilter;
        this.j8k_1 = readPermissions;
        this.k8k_1 = filterHashes;
        this.l8k_1 = frequency;
        this.m8k_1 = email;
        this.n8k_1 = push;
        this.o8k_1 = sms;
      }
      f40() {
        return this.h8k_1;
      }
      p9j(_id, requestedFilter, readPermissions, filterHashes, frequency, email, push, sms) {
        return new (EventSubscription())(_id, requestedFilter, readPermissions, filterHashes, frequency, email, push, sms);
      }
      q8k(_id, requestedFilter, readPermissions, filterHashes, frequency, email, push, sms, $super) {
        _id = _id === VOID ? this.h8k_1 : _id;
        requestedFilter = requestedFilter === VOID ? this.i8k_1 : requestedFilter;
        readPermissions = readPermissions === VOID ? this.j8k_1 : readPermissions;
        filterHashes = filterHashes === VOID ? this.k8k_1 : filterHashes;
        frequency = frequency === VOID ? this.l8k_1 : frequency;
        email = email === VOID ? this.m8k_1 : email;
        push = push === VOID ? this.n8k_1 : push;
        sms = sms === VOID ? this.o8k_1 : sms;
        return $super === VOID ? this.p9j(_id, requestedFilter, readPermissions, filterHashes, frequency, email, push, sms) : $super.p9j.call(this, _id, requestedFilter, readPermissions, filterHashes, frequency, email, push, sms);
      }
      toString() {
        return 'EventSubscription(_id=' + this.h8k_1.toString() + ', requestedFilter=' + this.i8k_1 + ', readPermissions=' + this.j8k_1 + ', filterHashes=' + toString(this.k8k_1) + ', frequency=' + this.l8k_1.toString() + ', email=' + this.m8k_1 + ', push=' + this.n8k_1 + ', sms=' + this.o8k_1 + ')';
      }
      hashCode() {
        var result = this.h8k_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.i8k_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.j8k_1) | 0;
        result = imul(result, 31) + hashCode(this.k8k_1) | 0;
        result = imul(result, 31) + this.l8k_1.hashCode() | 0;
        result = imul(result, 31) + getBooleanHashCode(this.m8k_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.n8k_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.o8k_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof EventSubscription()))
          return false;
        if (!this.h8k_1.equals(other.h8k_1))
          return false;
        if (!(this.i8k_1 === other.i8k_1))
          return false;
        if (!(this.j8k_1 === other.j8k_1))
          return false;
        if (!equals(this.k8k_1, other.k8k_1))
          return false;
        if (!this.l8k_1.equals(other.l8k_1))
          return false;
        if (!(this.m8k_1 === other.m8k_1))
          return false;
        if (!(this.n8k_1 === other.n8k_1))
          return false;
        if (!(this.o8k_1 === other.o8k_1))
          return false;
        return true;
      }
      static o9j(seen0, _id, requestedFilter, readPermissions, filterHashes, frequency, email, push, sms, serializationConstructorMarker) {
        Companion_getInstance_2();
        if (!(255 === (255 & seen0))) {
          throwMissingFieldException(seen0, 255, Companion_getInstance_2().b8k_1);
        }
        var $this = createThis(this);
        $this.h8k_1 = _id;
        $this.i8k_1 = requestedFilter;
        $this.j8k_1 = readPermissions;
        $this.k8k_1 = filterHashes;
        $this.l8k_1 = frequency;
        $this.m8k_1 = email;
        $this.n8k_1 = push;
        $this.o8k_1 = sms;
        return $this;
      }
    }
    initMetadataForClass($, 'EventSubscription', VOID, VOID, [HasId()], VOID, VOID, {0: Companion_getInstance_2});
    EventSubscriptionClass = $;
  }
  return EventSubscriptionClass;
}
var CompanionClass_2;
function Companion_2() {
  if (CompanionClass_2 === VOID) {
    class $ {
      constructor() {
        Companion_instance_2 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.notifications.UserEventType', null, 2);
        tmp0_serialDesc.a1b('user', false);
        tmp0_serialDesc.a1b('type', false);
        this.o8p_1 = tmp0_serialDesc;
      }
      c8k(typeSerial0) {
        return $serializer_2().n9j(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.c8k(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_2 = $;
  }
  return CompanionClass_2;
}
var Companion_instance_2;
function Companion_getInstance_3() {
  if (Companion_instance_2 === VOID)
    new (Companion_2())();
  return Companion_instance_2;
}
var $serializerClass_2;
function $serializer_2() {
  if ($serializerClass_2 === VOID) {
    class $ {
      static q9j() {
        var $this = createThis(this);
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.notifications.UserEventType', $this, 2);
        tmp0_serialDesc.a1b('user', false);
        tmp0_serialDesc.a1b('type', false);
        $this.l9j_1 = tmp0_serialDesc;
        return $this;
      }
      r9j(encoder, value) {
        var tmp0_desc = this.l9j_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.c15(tmp0_desc, 0, this.m9j_1, value.t8p_1);
        tmp1_output.c15(tmp0_desc, 1, $serializer_getInstance(), value.u8p_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.r9j(encoder, value instanceof UserEventType() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.l9j_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.l13(tmp0_desc);
        if (tmp6_input.a14()) {
          tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, this.m9j_1, tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.x13(tmp0_desc, 1, $serializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, this.m9j_1, tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.x13(tmp0_desc, 1, $serializer_getInstance(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return UserEventType().s9j(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.l9j_1;
      }
      r1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.m9j_1, $serializer_getInstance()];
      }
      s1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.m9j_1];
      }
      static n9j(typeSerial0) {
        var $this = this.q9j();
        $this.m9j_1 = typeSerial0;
        return $this;
      }
    }
    initMetadataForClass($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_2 = $;
  }
  return $serializerClass_2;
}
var UserEventTypeClass;
function UserEventType() {
  if (UserEventTypeClass === VOID) {
    class $ {
      constructor(user, type) {
        Companion_getInstance_3();
        this.t8p_1 = user;
        this.u8p_1 = type;
      }
      t9j(other) {
        // Inline function 'kotlin.takeIf' call
        var this_0 = compareTo(this.t8p_1, other.t8p_1);
        var tmp;
        if (!(this_0 === 0)) {
          tmp = this_0;
        } else {
          tmp = null;
        }
        var tmp0_elvis_lhs = tmp;
        return tmp0_elvis_lhs == null ? compareTo(this.u8p_1.v8l_1, other.u8p_1.v8l_1) : tmp0_elvis_lhs;
      }
      d(other) {
        return this.t9j(other instanceof UserEventType() ? other : THROW_CCE());
      }
      u9j(user, type) {
        return new (UserEventType())(user, type);
      }
      w8p(user, type, $super) {
        user = user === VOID ? this.t8p_1 : user;
        type = type === VOID ? this.u8p_1 : type;
        return $super === VOID ? this.u9j(user, type) : $super.u9j.call(this, user, type);
      }
      toString() {
        return 'UserEventType(user=' + toString(this.t8p_1) + ', type=' + this.u8p_1.toString() + ')';
      }
      hashCode() {
        var result = hashCode(this.t8p_1);
        result = imul(result, 31) + this.u8p_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof UserEventType()))
          return false;
        if (!equals(this.t8p_1, other.t8p_1))
          return false;
        if (!this.u8p_1.equals(other.u8p_1))
          return false;
        return true;
      }
      static s9j(seen0, user, type, serializationConstructorMarker) {
        Companion_getInstance_3();
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, Companion_getInstance_3().o8p_1);
        }
        var $this = createThis(this);
        $this.t8p_1 = user;
        $this.u8p_1 = type;
        return $this;
      }
    }
    initMetadataForClass($, 'UserEventType', VOID, VOID, [Comparable()], VOID, VOID, {0: Companion_getInstance_3});
    UserEventTypeClass = $;
  }
  return UserEventTypeClass;
}
var CompanionClass_3;
function Companion_3() {
  if (CompanionClass_3 === VOID) {
    class $ {
      constructor() {
        Companion_instance_3 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.notifications.Notification', null, 9);
        tmp0_serialDesc.a1b('_id', true);
        tmp0_serialDesc.a1b('event', false);
        tmp0_serialDesc.a1b('user', false);
        tmp0_serialDesc.a1b('content', false);
        tmp0_serialDesc.a1b('sendAt', false);
        tmp0_serialDesc.a1b('email', true);
        tmp0_serialDesc.a1b('push', true);
        tmp0_serialDesc.a1b('sms', true);
        tmp0_serialDesc.a1b('inAppOnlySent', true);
        this.f8m_1 = tmp0_serialDesc;
      }
      g8m(typeSerial0, typeSerial1) {
        return $serializer_3().y9j(typeSerial0, typeSerial1);
      }
      f1c(typeParamsSerializers) {
        return this.g8m(typeParamsSerializers[0], typeParamsSerializers[1]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_3 = $;
  }
  return CompanionClass_3;
}
var Companion_instance_3;
function Companion_getInstance_4() {
  if (Companion_instance_3 === VOID)
    new (Companion_3())();
  return Companion_instance_3;
}
var $serializerClass_3;
function $serializer_3() {
  if ($serializerClass_3 === VOID) {
    class $ {
      static z9j() {
        var $this = createThis(this);
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.notifications.Notification', $this, 9);
        tmp0_serialDesc.a1b('_id', true);
        tmp0_serialDesc.a1b('event', false);
        tmp0_serialDesc.a1b('user', false);
        tmp0_serialDesc.a1b('content', false);
        tmp0_serialDesc.a1b('sendAt', false);
        tmp0_serialDesc.a1b('email', true);
        tmp0_serialDesc.a1b('push', true);
        tmp0_serialDesc.a1b('sms', true);
        tmp0_serialDesc.a1b('inAppOnlySent', true);
        $this.v9j_1 = tmp0_serialDesc;
        return $this;
      }
      a9k(encoder, value) {
        var tmp0_desc = this.v9j_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.l8m_1.equals(Companion_getInstance().k2p())) {
          tmp1_output.c15(tmp0_desc, 0, DeferToContextualUuidSerializer_getInstance(), value.l8m_1);
        }
        tmp1_output.c15(tmp0_desc, 1, $serializer_getInstance_0(), value.m8m_1);
        tmp1_output.c15(tmp0_desc, 2, this.w9j_1, value.n8m_1);
        tmp1_output.c15(tmp0_desc, 3, this.x9j_1, value.o8m_1);
        tmp1_output.c15(tmp0_desc, 4, InstantIso8601Serializer_getInstance(), value.p8m_1);
        if (tmp1_output.h15(tmp0_desc, 5) ? true : !(value.q8m_1 == null)) {
          tmp1_output.d15(tmp0_desc, 5, BooleanSerializer_getInstance(), value.q8m_1);
        }
        if (tmp1_output.h15(tmp0_desc, 6) ? true : !(value.r8m_1 == null)) {
          tmp1_output.d15(tmp0_desc, 6, BooleanSerializer_getInstance(), value.r8m_1);
        }
        if (tmp1_output.h15(tmp0_desc, 7) ? true : !(value.s8m_1 == null)) {
          tmp1_output.d15(tmp0_desc, 7, BooleanSerializer_getInstance(), value.s8m_1);
        }
        if (tmp1_output.h15(tmp0_desc, 8) ? true : !(value.t8m_1 === false)) {
          tmp1_output.s14(tmp0_desc, 8, value.t8m_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.a9k(encoder, value instanceof Notification() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.v9j_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = false;
        var tmp13_input = decoder.l13(tmp0_desc);
        if (tmp13_input.a14()) {
          tmp4_local0 = tmp13_input.x13(tmp0_desc, 0, DeferToContextualUuidSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp13_input.x13(tmp0_desc, 1, $serializer_getInstance_0(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp13_input.x13(tmp0_desc, 2, this.w9j_1, tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp13_input.x13(tmp0_desc, 3, this.x9j_1, tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp13_input.x13(tmp0_desc, 4, InstantIso8601Serializer_getInstance(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp13_input.z13(tmp0_desc, 5, BooleanSerializer_getInstance(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp13_input.z13(tmp0_desc, 6, BooleanSerializer_getInstance(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp13_input.z13(tmp0_desc, 7, BooleanSerializer_getInstance(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp13_input.n13(tmp0_desc, 8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp13_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp13_input.x13(tmp0_desc, 0, DeferToContextualUuidSerializer_getInstance(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp13_input.x13(tmp0_desc, 1, $serializer_getInstance_0(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp13_input.x13(tmp0_desc, 2, this.w9j_1, tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp13_input.x13(tmp0_desc, 3, this.x9j_1, tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp13_input.x13(tmp0_desc, 4, InstantIso8601Serializer_getInstance(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp13_input.z13(tmp0_desc, 5, BooleanSerializer_getInstance(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp13_input.z13(tmp0_desc, 6, BooleanSerializer_getInstance(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp13_input.z13(tmp0_desc, 7, BooleanSerializer_getInstance(), tmp11_local7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp13_input.n13(tmp0_desc, 8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp13_input.m13(tmp0_desc);
        return Notification().b9k(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, null);
      }
      az() {
        return this.v9j_1;
      }
      r1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [DeferToContextualUuidSerializer_getInstance(), $serializer_getInstance_0(), this.w9j_1, this.x9j_1, InstantIso8601Serializer_getInstance(), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), BooleanSerializer_getInstance()];
      }
      s1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.w9j_1, this.x9j_1];
      }
      static y9j(typeSerial0, typeSerial1) {
        var $this = this.z9j();
        $this.w9j_1 = typeSerial0;
        $this.x9j_1 = typeSerial1;
        return $this;
      }
    }
    initMetadataForClass($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_3 = $;
  }
  return $serializerClass_3;
}
var NotificationClass;
function Notification() {
  if (NotificationClass === VOID) {
    class $ {
      constructor(_id, event, user, content, sendAt, email, push, sms, inAppOnlySent) {
        Companion_getInstance_4();
        _id = _id === VOID ? Companion_getInstance().k2p() : _id;
        email = email === VOID ? null : email;
        push = push === VOID ? null : push;
        sms = sms === VOID ? null : sms;
        inAppOnlySent = inAppOnlySent === VOID ? false : inAppOnlySent;
        this.l8m_1 = _id;
        this.m8m_1 = event;
        this.n8m_1 = user;
        this.o8m_1 = content;
        this.p8m_1 = sendAt;
        this.q8m_1 = email;
        this.r8m_1 = push;
        this.s8m_1 = sms;
        this.t8m_1 = inAppOnlySent;
      }
      f40() {
        return this.l8m_1;
      }
      c9k(_id, event, user, content, sendAt, email, push, sms, inAppOnlySent) {
        return new (Notification())(_id, event, user, content, sendAt, email, push, sms, inAppOnlySent);
      }
      v8m(_id, event, user, content, sendAt, email, push, sms, inAppOnlySent, $super) {
        _id = _id === VOID ? this.l8m_1 : _id;
        event = event === VOID ? this.m8m_1 : event;
        user = user === VOID ? this.n8m_1 : user;
        content = content === VOID ? this.o8m_1 : content;
        sendAt = sendAt === VOID ? this.p8m_1 : sendAt;
        email = email === VOID ? this.q8m_1 : email;
        push = push === VOID ? this.r8m_1 : push;
        sms = sms === VOID ? this.s8m_1 : sms;
        inAppOnlySent = inAppOnlySent === VOID ? this.t8m_1 : inAppOnlySent;
        return $super === VOID ? this.c9k(_id, event, user, content, sendAt, email, push, sms, inAppOnlySent) : $super.c9k.call(this, _id, event, user, content, sendAt, email, push, sms, inAppOnlySent);
      }
      toString() {
        return 'Notification(_id=' + this.l8m_1.toString() + ', event=' + this.m8m_1.toString() + ', user=' + toString_0(this.n8m_1) + ', content=' + toString(this.o8m_1) + ', sendAt=' + this.p8m_1.toString() + ', email=' + this.q8m_1 + ', push=' + this.r8m_1 + ', sms=' + this.s8m_1 + ', inAppOnlySent=' + this.t8m_1 + ')';
      }
      hashCode() {
        var result = this.l8m_1.hashCode();
        result = imul(result, 31) + this.m8m_1.hashCode() | 0;
        result = imul(result, 31) + (this.n8m_1 == null ? 0 : hashCode(this.n8m_1)) | 0;
        result = imul(result, 31) + hashCode(this.o8m_1) | 0;
        result = imul(result, 31) + this.p8m_1.hashCode() | 0;
        result = imul(result, 31) + (this.q8m_1 == null ? 0 : getBooleanHashCode(this.q8m_1)) | 0;
        result = imul(result, 31) + (this.r8m_1 == null ? 0 : getBooleanHashCode(this.r8m_1)) | 0;
        result = imul(result, 31) + (this.s8m_1 == null ? 0 : getBooleanHashCode(this.s8m_1)) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.t8m_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Notification()))
          return false;
        if (!this.l8m_1.equals(other.l8m_1))
          return false;
        if (!this.m8m_1.equals(other.m8m_1))
          return false;
        if (!equals(this.n8m_1, other.n8m_1))
          return false;
        if (!equals(this.o8m_1, other.o8m_1))
          return false;
        if (!this.p8m_1.equals(other.p8m_1))
          return false;
        if (!(this.q8m_1 == other.q8m_1))
          return false;
        if (!(this.r8m_1 == other.r8m_1))
          return false;
        if (!(this.s8m_1 == other.s8m_1))
          return false;
        if (!(this.t8m_1 === other.t8m_1))
          return false;
        return true;
      }
      static b9k(seen0, _id, event, user, content, sendAt, email, push, sms, inAppOnlySent, serializationConstructorMarker) {
        Companion_getInstance_4();
        if (!(30 === (30 & seen0))) {
          throwMissingFieldException(seen0, 30, Companion_getInstance_4().f8m_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.l8m_1 = Companion_getInstance().k2p();
        else
          $this.l8m_1 = _id;
        $this.m8m_1 = event;
        $this.n8m_1 = user;
        $this.o8m_1 = content;
        $this.p8m_1 = sendAt;
        if (0 === (seen0 & 32))
          $this.q8m_1 = null;
        else
          $this.q8m_1 = email;
        if (0 === (seen0 & 64))
          $this.r8m_1 = null;
        else
          $this.r8m_1 = push;
        if (0 === (seen0 & 128))
          $this.s8m_1 = null;
        else
          $this.s8m_1 = sms;
        if (0 === (seen0 & 256))
          $this.t8m_1 = false;
        else
          $this.t8m_1 = inAppOnlySent;
        return $this;
      }
    }
    initMetadataForClass($, 'Notification', VOID, VOID, [HasId()], VOID, VOID, {0: Companion_getInstance_4});
    NotificationClass = $;
  }
  return NotificationClass;
}
var CompanionClass_4;
function Companion_4() {
  if (CompanionClass_4 === VOID) {
    class $ {
      k2a() {
        return $serializer_getInstance_0();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_4 = $;
  }
  return CompanionClass_4;
}
var Companion_instance_4;
function Companion_getInstance_5() {
  return Companion_instance_4;
}
var $serializerClass_4;
function $serializer_4() {
  if ($serializerClass_4 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_0 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.notifications.Event', this, 4);
        tmp0_serialDesc.a1b('_id', true);
        tmp0_serialDesc.a1b('time', false);
        tmp0_serialDesc.a1b('type', false);
        tmp0_serialDesc.a1b('target', false);
        this.d9k_1 = tmp0_serialDesc;
      }
      e9k(encoder, value) {
        var tmp0_desc = this.d9k_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.i8j_1.equals(Companion_getInstance().k2p())) {
          tmp1_output.c15(tmp0_desc, 0, DeferToContextualUuidSerializer_getInstance(), value.i8j_1);
        }
        tmp1_output.c15(tmp0_desc, 1, InstantIso8601Serializer_getInstance(), value.j8j_1);
        tmp1_output.c15(tmp0_desc, 2, $serializer_getInstance(), value.k8j_1);
        tmp1_output.a15(tmp0_desc, 3, value.l8j_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.e9k(encoder, value instanceof Event() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.d9k_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_input = decoder.l13(tmp0_desc);
        if (tmp8_input.a14()) {
          tmp4_local0 = tmp8_input.x13(tmp0_desc, 0, DeferToContextualUuidSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp8_input.x13(tmp0_desc, 1, InstantIso8601Serializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp8_input.x13(tmp0_desc, 2, $serializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp8_input.v13(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp8_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp8_input.x13(tmp0_desc, 0, DeferToContextualUuidSerializer_getInstance(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp8_input.x13(tmp0_desc, 1, InstantIso8601Serializer_getInstance(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp8_input.x13(tmp0_desc, 2, $serializer_getInstance(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp8_input.v13(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp8_input.m13(tmp0_desc);
        return Event().f9k(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
      }
      az() {
        return this.d9k_1;
      }
      r1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [DeferToContextualUuidSerializer_getInstance(), InstantIso8601Serializer_getInstance(), $serializer_getInstance(), StringSerializer_getInstance()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_4 = $;
  }
  return $serializerClass_4;
}
var $serializer_instance_0;
function $serializer_getInstance_0() {
  if ($serializer_instance_0 === VOID)
    new ($serializer_4())();
  return $serializer_instance_0;
}
var EventClass;
function Event() {
  if (EventClass === VOID) {
    class $ {
      constructor(_id, time, type, target) {
        _id = _id === VOID ? Companion_getInstance().k2p() : _id;
        this.i8j_1 = _id;
        this.j8j_1 = time;
        this.k8j_1 = type;
        this.l8j_1 = target;
      }
      f40() {
        return this.i8j_1;
      }
      g9k(_id, time, type, target) {
        return new (Event())(_id, time, type, target);
      }
      n8j(_id, time, type, target, $super) {
        _id = _id === VOID ? this.i8j_1 : _id;
        time = time === VOID ? this.j8j_1 : time;
        type = type === VOID ? this.k8j_1 : type;
        target = target === VOID ? this.l8j_1 : target;
        return $super === VOID ? this.g9k(_id, time, type, target) : $super.g9k.call(this, _id, time, type, target);
      }
      toString() {
        return 'Event(_id=' + this.i8j_1.toString() + ', time=' + this.j8j_1.toString() + ', type=' + this.k8j_1.toString() + ', target=' + this.l8j_1 + ')';
      }
      hashCode() {
        var result = this.i8j_1.hashCode();
        result = imul(result, 31) + this.j8j_1.hashCode() | 0;
        result = imul(result, 31) + this.k8j_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.l8j_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Event()))
          return false;
        if (!this.i8j_1.equals(other.i8j_1))
          return false;
        if (!this.j8j_1.equals(other.j8j_1))
          return false;
        if (!this.k8j_1.equals(other.k8j_1))
          return false;
        if (!(this.l8j_1 === other.l8j_1))
          return false;
        return true;
      }
      static f9k(seen0, _id, time, type, target, serializationConstructorMarker) {
        if (!(14 === (14 & seen0))) {
          throwMissingFieldException(seen0, 14, $serializer_getInstance_0().d9k_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.i8j_1 = Companion_getInstance().k2p();
        else
          $this.i8j_1 = _id;
        $this.j8j_1 = time;
        $this.k8j_1 = type;
        $this.l8j_1 = target;
        return $this;
      }
    }
    initMetadataForClass($, 'Event', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_0});
    EventClass = $;
  }
  return EventClass;
}
function NotificationFrequency$Companion$$childSerializers$_anonymous__3774xl() {
  return createSimpleEnumSerializer('kotlinx.datetime.DayOfWeek', values());
}
var CompanionClass_5;
function Companion_5() {
  if (CompanionClass_5 === VOID) {
    class $ {
      constructor() {
        Companion_instance_5 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.k8o_1 = [null, lazy(tmp_0, NotificationFrequency$Companion$$childSerializers$_anonymous__3774xl), null];
      }
      e9j() {
        return new (NotificationFrequency())(null, null, null);
      }
      k2a() {
        return $serializer_getInstance_1();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_5 = $;
  }
  return CompanionClass_5;
}
var Companion_instance_5;
function Companion_getInstance_6() {
  if (Companion_instance_5 === VOID)
    new (Companion_5())();
  return Companion_instance_5;
}
var $serializerClass_5;
function $serializer_5() {
  if ($serializerClass_5 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_1 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.notifications.NotificationFrequency', this, 3);
        tmp0_serialDesc.a1b('onlyAt', false);
        tmp0_serialDesc.a1b('onlyOn', false);
        tmp0_serialDesc.a1b('batchMinutes', false);
        this.h9k_1 = tmp0_serialDesc;
      }
      i9k(encoder, value) {
        var tmp0_desc = this.h9k_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_6().k8o_1;
        tmp1_output.d15(tmp0_desc, 0, $serializer_getInstance_3(), value.p8o_1);
        tmp1_output.d15(tmp0_desc, 1, tmp2_cached[1].f2(), value.q8o_1);
        tmp1_output.d15(tmp0_desc, 2, IntSerializer_getInstance(), value.r8o_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.i9k(encoder, value instanceof NotificationFrequency() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.h9k_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.l13(tmp0_desc);
        var tmp8_cached = Companion_getInstance_6().k8o_1;
        if (tmp7_input.a14()) {
          tmp4_local0 = tmp7_input.z13(tmp0_desc, 0, $serializer_getInstance_3(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp7_input.z13(tmp0_desc, 1, tmp8_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp7_input.z13(tmp0_desc, 2, IntSerializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.z13(tmp0_desc, 0, $serializer_getInstance_3(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp7_input.z13(tmp0_desc, 1, tmp8_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp7_input.z13(tmp0_desc, 2, IntSerializer_getInstance(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp7_input.m13(tmp0_desc);
        return NotificationFrequency().j9k(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      az() {
        return this.h9k_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance_6().k8o_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [get_nullable($serializer_getInstance_3()), get_nullable(tmp0_cached[1].f2()), get_nullable(IntSerializer_getInstance())];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_5 = $;
  }
  return $serializerClass_5;
}
var $serializer_instance_1;
function $serializer_getInstance_1() {
  if ($serializer_instance_1 === VOID)
    new ($serializer_5())();
  return $serializer_instance_1;
}
var NotificationFrequencyClass;
function NotificationFrequency() {
  if (NotificationFrequencyClass === VOID) {
    class $ {
      constructor(onlyAt, onlyOn, batchMinutes) {
        Companion_getInstance_6();
        this.p8o_1 = onlyAt;
        this.q8o_1 = onlyOn;
        this.r8o_1 = batchMinutes;
      }
      k9k(onlyAt, onlyOn, batchMinutes) {
        return new (NotificationFrequency())(onlyAt, onlyOn, batchMinutes);
      }
      t8o(onlyAt, onlyOn, batchMinutes, $super) {
        onlyAt = onlyAt === VOID ? this.p8o_1 : onlyAt;
        onlyOn = onlyOn === VOID ? this.q8o_1 : onlyOn;
        batchMinutes = batchMinutes === VOID ? this.r8o_1 : batchMinutes;
        return $super === VOID ? this.k9k(onlyAt, onlyOn, batchMinutes) : $super.k9k.call(this, onlyAt, onlyOn, batchMinutes);
      }
      toString() {
        return 'NotificationFrequency(onlyAt=' + toString_0(this.p8o_1) + ', onlyOn=' + toString_0(this.q8o_1) + ', batchMinutes=' + this.r8o_1 + ')';
      }
      hashCode() {
        var result = this.p8o_1 == null ? 0 : this.p8o_1.hashCode();
        result = imul(result, 31) + (this.q8o_1 == null ? 0 : this.q8o_1.hashCode()) | 0;
        result = imul(result, 31) + (this.r8o_1 == null ? 0 : this.r8o_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof NotificationFrequency()))
          return false;
        if (!equals(this.p8o_1, other.p8o_1))
          return false;
        if (!equals(this.q8o_1, other.q8o_1))
          return false;
        if (!(this.r8o_1 == other.r8o_1))
          return false;
        return true;
      }
      static j9k(seen0, onlyAt, onlyOn, batchMinutes, serializationConstructorMarker) {
        Companion_getInstance_6();
        if (!(7 === (7 & seen0))) {
          throwMissingFieldException(seen0, 7, $serializer_getInstance_1().h9k_1);
        }
        var $this = createThis(this);
        $this.p8o_1 = onlyAt;
        $this.q8o_1 = onlyOn;
        $this.r8o_1 = batchMinutes;
        return $this;
      }
    }
    initMetadataForClass($, 'NotificationFrequency', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_1});
    NotificationFrequencyClass = $;
  }
  return NotificationFrequencyClass;
}
var CompanionClass_6;
function Companion_6() {
  if (CompanionClass_6 === VOID) {
    class $ {
      k2a() {
        return $serializer_getInstance_2();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_6 = $;
  }
  return CompanionClass_6;
}
var Companion_instance_6;
function Companion_getInstance_7() {
  return Companion_instance_6;
}
var $serializerClass_6;
function $serializer_6() {
  if ($serializerClass_6 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_2 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.notifications.NotificationContent.Basic', this, 3);
        tmp0_serialDesc.a1b('title', false);
        tmp0_serialDesc.a1b('body', false);
        tmp0_serialDesc.a1b('url', true);
        this.l9k_1 = tmp0_serialDesc;
      }
      m9k(encoder, value) {
        var tmp0_desc = this.l9k_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.a15(tmp0_desc, 0, value.o8i_1);
        tmp1_output.a15(tmp0_desc, 1, value.p8i_1);
        if (tmp1_output.h15(tmp0_desc, 2) ? true : !(value.q8i_1 == null)) {
          tmp1_output.d15(tmp0_desc, 2, StringSerializer_getInstance(), value.q8i_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.m9k(encoder, value instanceof Basic() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.l9k_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.l13(tmp0_desc);
        if (tmp7_input.a14()) {
          tmp4_local0 = tmp7_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp7_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp7_input.z13(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp7_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp7_input.z13(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp7_input.m13(tmp0_desc);
        return Basic().n9k(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      az() {
        return this.l9k_1;
      }
      r1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_6 = $;
  }
  return $serializerClass_6;
}
var $serializer_instance_2;
function $serializer_getInstance_2() {
  if ($serializer_instance_2 === VOID)
    new ($serializer_6())();
  return $serializer_instance_2;
}
var BasicClass;
function Basic() {
  if (BasicClass === VOID) {
    class $ {
      constructor(title, body, url) {
        url = url === VOID ? null : url;
        this.o8i_1 = title;
        this.p8i_1 = body;
        this.q8i_1 = url;
      }
      o9k(title, body, url) {
        return new (Basic())(title, body, url);
      }
      s8i(title, body, url, $super) {
        title = title === VOID ? this.o8i_1 : title;
        body = body === VOID ? this.p8i_1 : body;
        url = url === VOID ? this.q8i_1 : url;
        return $super === VOID ? this.o9k(title, body, url) : $super.o9k.call(this, title, body, url);
      }
      toString() {
        return 'Basic(title=' + this.o8i_1 + ', body=' + this.p8i_1 + ', url=' + this.q8i_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.o8i_1);
        result = imul(result, 31) + getStringHashCode(this.p8i_1) | 0;
        result = imul(result, 31) + (this.q8i_1 == null ? 0 : getStringHashCode(this.q8i_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Basic()))
          return false;
        if (!(this.o8i_1 === other.o8i_1))
          return false;
        if (!(this.p8i_1 === other.p8i_1))
          return false;
        if (!(this.q8i_1 == other.q8i_1))
          return false;
        return true;
      }
      static n9k(seen0, title, body, url, serializationConstructorMarker) {
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_2().l9k_1);
        }
        var $this = createThis(this);
        $this.o8i_1 = title;
        $this.p8i_1 = body;
        if (0 === (seen0 & 4))
          $this.q8i_1 = null;
        else
          $this.q8i_1 = url;
        return $this;
      }
    }
    initMetadataForClass($, 'Basic', VOID, VOID, [NotificationContent()], VOID, VOID, {0: $serializer_getInstance_2});
    BasicClass = $;
  }
  return BasicClass;
}
var NotificationContentClass;
function NotificationContent() {
  if (NotificationContentClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'NotificationContent');
    NotificationContentClass = $;
  }
  return NotificationContentClass;
}
var CompanionClass_7;
function Companion_7() {
  if (CompanionClass_7 === VOID) {
    class $ {
      k2a() {
        return $serializer_getInstance_3();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_7 = $;
  }
  return CompanionClass_7;
}
var Companion_instance_7;
function Companion_getInstance_8() {
  return Companion_instance_7;
}
var $serializerClass_7;
function $serializer_7() {
  if ($serializerClass_7 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_3 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.notifications.TimeInZone', this, 2);
        tmp0_serialDesc.a1b('time', false);
        tmp0_serialDesc.a1b('zone', false);
        this.p9k_1 = tmp0_serialDesc;
      }
      q9k(encoder, value) {
        var tmp0_desc = this.p9k_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.c15(tmp0_desc, 0, LocalTimeIso8601Serializer_getInstance(), value.g8p_1);
        tmp1_output.c15(tmp0_desc, 1, TimeZoneSerializer_getInstance(), value.h8p_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.q9k(encoder, value instanceof TimeInZone() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.p9k_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.l13(tmp0_desc);
        if (tmp6_input.a14()) {
          tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, LocalTimeIso8601Serializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.x13(tmp0_desc, 1, TimeZoneSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, LocalTimeIso8601Serializer_getInstance(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.x13(tmp0_desc, 1, TimeZoneSerializer_getInstance(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return TimeInZone().r9k(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.p9k_1;
      }
      r1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [LocalTimeIso8601Serializer_getInstance(), TimeZoneSerializer_getInstance()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_7 = $;
  }
  return $serializerClass_7;
}
var $serializer_instance_3;
function $serializer_getInstance_3() {
  if ($serializer_instance_3 === VOID)
    new ($serializer_7())();
  return $serializer_instance_3;
}
var TimeInZoneClass;
function TimeInZone() {
  if (TimeInZoneClass === VOID) {
    class $ {
      constructor(time, zone) {
        this.g8p_1 = time;
        this.h8p_1 = zone;
      }
      s9k(time, zone) {
        return new (TimeInZone())(time, zone);
      }
      j8p(time, zone, $super) {
        time = time === VOID ? this.g8p_1 : time;
        zone = zone === VOID ? this.h8p_1 : zone;
        return $super === VOID ? this.s9k(time, zone) : $super.s9k.call(this, time, zone);
      }
      toString() {
        return 'TimeInZone(time=' + this.g8p_1.toString() + ', zone=' + this.h8p_1.toString() + ')';
      }
      hashCode() {
        var result = this.g8p_1.hashCode();
        result = imul(result, 31) + this.h8p_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof TimeInZone()))
          return false;
        if (!this.g8p_1.equals(other.g8p_1))
          return false;
        if (!this.h8p_1.equals(other.h8p_1))
          return false;
        return true;
      }
      static r9k(seen0, time, zone, serializationConstructorMarker) {
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_3().p9k_1);
        }
        var $this = createThis(this);
        $this.g8p_1 = time;
        $this.h8p_1 = zone;
        return $this;
      }
    }
    initMetadataForClass($, 'TimeInZone', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_3});
    TimeInZoneClass = $;
  }
  return TimeInZoneClass;
}
//region block: init
Companion_instance_4 = new (Companion_4())();
Companion_instance_6 = new (Companion_6())();
Companion_instance_7 = new (Companion_7())();
//endregion
//region block: exports
export {
  EventSubscription as EventSubscription13rxmq485x98c,
  EventType as EventType2bd9gu34l4i61,
  Event as Event1xu0tgxxbb919,
  Basic as Basic3vvjt6j04wm3x,
  NotificationContent as NotificationContent14rxxdz7igy9l,
  NotificationFrequency as NotificationFrequency6nobdojsdzj9,
  Notification as Notification36ye7lys64zyi,
  TimeInZone as TimeInZone1aol3tfiawf3k,
  UserEventType as UserEventType3ayinm14vltts,
  Companion_instance_4 as Companion_instancevt78qdise4qh,
  Companion_getInstance_2 as Companion_getInstance2a6946bmnnmyk,
  Companion_getInstance_1 as Companion_getInstance1pftqwqxp7rhm,
  Companion_getInstance_0 as Companion_getInstanceidce664s8rcz,
  Companion_getInstance_4 as Companion_getInstance2tq82jyrde4r,
  Companion_instance_6 as Companion_instance2aoezwcxpm6pa,
  Companion_getInstance_6 as Companion_getInstancengmzgdfq20id,
  Companion_instance_7 as Companion_instance20vpendjsus8n,
  Companion_getInstance_3 as Companion_getInstance23zmguv2nlvyd,
};
//endregion

//# sourceMappingURL=shared.mjs.map
